import { render, staticRenderFns } from "./CBooleanSwitch.vue?vue&type=template&id=87cf2952&scoped=true&"
import script from "./CBooleanSwitch.vue?vue&type=script&lang=ts&"
export * from "./CBooleanSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cf2952",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
